import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';
import { api } from '../../../services/api.js';
import './AvaliacaoPopup.css';

const AvaliacaoPopup = ({ usuario, datault, codigoRestaurante,nomeRestaurante, onClose }) => {
  const [nota, setNota] = useState(null);
  const [comentario, setComentario] = useState('');
  const [hovered, setHovered] = useState(null);

  const handleSubmit = async () => {
    if (!nota) {
      Swal.fire('Erro', 'Você deve escolher uma nota.', 'warning');
      return;
    }
    if (nota <= 2 && comentario.trim() === '') {
      Swal.fire('Erro', 'Comentário obrigatório para notas até 2.', 'warning');
      return;
    }

    const payload = {
      codigo: codigoRestaurante || '0',
      avaliacao: nota,
      comentario,
      data: datault // formato dd/mm/yyyy
    };

    try {
      const res = await api.post(`/restaurante/${usuario}/avaliar`, payload);
      console.log(payload)
      if (res.status === 201) {
        Swal.fire('Obrigado!', 'Sua avaliação foi registrada.', 'success');
        onClose();
      } else {
        const msg = res.data?.mensagem || 'Erro ao registrar avaliação';
        Swal.fire('Erro', msg, 'error');
      }
    } catch (err) {
      let msg = 'Falha ao acessar o servidor';
      if (err.response?.data?.erro) {
        msg = Array.isArray(err.response.data.erro) ? err.response.data.erro[0] : err.response.data.erro;
      }
      Swal.fire('Erro', msg, 'error');
    }
  };

  return (
    <Modal show centered contentClassName="avaliacao-modal">
      <Modal.Header className="border-0">
        <Modal.Title className="w-100 text-center">Qual nota você daria para sua última refeição?</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="text-danger fw-bold mb-2">{datault}</div>
        <div className="text-uppercase text-danger mb-3">{codigoRestaurante} - {nomeRestaurante}</div>
        <div className="d-flex justify-content-center my-3">
          {[1, 2, 3, 4, 5].map((n) => (
            <FontAwesomeIcon
              key={n}
              icon={(nota >= n || hovered >= n) ? solidStar : regularStar}
              className="star"
              onMouseEnter={() => setHovered(n)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => setNota(n)}
            />
          ))}
        </div>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Quer comentar sua nota?"
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
          className="mb-3"
        />
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-center">
        <Button variant="dark" className="px-5 rounded-pill" onClick={handleSubmit}>Confirmar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AvaliacaoPopup;
